/* eslint i18next/no-literal-string: 0 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import Cookies from 'js-cookie'

const BobLinks = () => {
    const [t] = useTranslation()
    return (
        <div className="menuSection" style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="menuSection__title">{t('Les sites de Bob')}</div>
            <div className="menuSection__items">
                <a href="https://www.bobtv.fr" target="_blank" rel="noreferrer" className="menuSection__item">
                    BobTV
                </a>
                <a href="https://bobstore.fr/" target="_blank" rel="noreferrer" className="menuSection__item">
                    Bobstore
                </a>
            </div>
            <div
                className={'cookieSettings'}
                onClick={() => {
                    Cookies.remove('cookieConsent')
                    window.location.reload()
                }}
            >
                {t('Cookie Management')}
            </div>
        </div>
    )
}

export default BobLinks
